import { render, staticRenderFns } from "./DrugReport.vue?vue&type=template&id=666c506f&scoped=true&"
import script from "./DrugReport.vue?vue&type=script&lang=js&"
export * from "./DrugReport.vue?vue&type=script&lang=js&"
import style0 from "./DrugReport.vue?vue&type=style&index=0&id=666c506f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666c506f",
  null
  
)

export default component.exports